<!-- multi-answer-button-list component -->
<div [class]="cssClass + ' multi-answer-button-list'">
    <ng-container *ngFor="let option of options; let i = index">
        <div 
            [class]="'stateful-custom-button ' + cssClass + '-item' " 
            [attr.aria-label]="option.name + ' button'"
        >
            <a 
                [class.selected]="option.selected" 
                (click)="this.onClick(i)" 
                (keydown.Space)="this.onClick(i)"    
                (keydown.enter)="this.onClick(i)" 
                tabindex="0"
            >
                <span><span [innerHTML]="option.name"></span></span>
            </a>
        </div>
    </ng-container>
</div>